import slugify from "slugify";

export function stringToSearchPlayers(text: string) {
  if (typeof text !== "string") return "";

  try {
    return slugify(text, " ")
      .replace(/[.·/_\-,:;]+/g, " ")
      .replace(/[\s]+/g, " ")
      .trim()
      .toUpperCase();
  } catch (e) {
    return text
      .replace(/[.·/_\-,:;]+/g, " ")
      .replace(/[\s]+/g, " ")
      .trim()
      .toUpperCase();
  }
}

export function formatarMatricula(gestor: string | number): string {
  if (!gestor) return "";
  
  // Converte para string e remove o F se existir
  let gestorStr = String(gestor).toUpperCase().replace(/^F/, "");
  
  // Remove caracteres não numéricos
  gestorStr = gestorStr.replace(/\D/g, "");
  
  // Preenche com zeros à esquerda até ter 7 dígitos
  gestorStr = gestorStr.padStart(7, "0");
  
  // Adiciona o F no início
  return `F${gestorStr}`;
}
